import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import IQBPaymentCard from "../../../../models/IQBPaymentCard";
import OwLabel from "../../OwLabel/OwLabel";
import OwSelectOption from "../../OwSelectOption/OwSelectOption";
import IDeleteACardDTO from "../../../../models/DTO/IDeleteACardDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IOrder from "../../../../models/IOrder";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import { SocketContext } from "../../../../contexts/SocketContext";
import OwButton from "../../OwButton/OwButton";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import IOnDeleteACardDTO from "../../../../models/DTO/IOnDeleteACardDTO";
import { QbPaymentContext } from "../../../../contexts/QbPaymentContext";
import IUpdateOrderCardToUseDTO from "../../../../models/DTO/IUpdateOrderCardToUseDTO";

type Props = {
    orderModel: IOrder;
    existingCards: IQBPaymentCard[];
    getExistingCardsActive: boolean;
    getCards: () => void;
};

export const QuickBooksPaymentExistingCards = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const qbPaymentContext = useContext(QbPaymentContext);

    const [existingCard, setExistingCard] = useState<IQBPaymentCard | undefined>(
        props.orderModel.qbo_CardToUseDetail ? props.orderModel.qbo_CardToUseDetail : undefined
    );
    const [isChargeDisabled, setIsChargeDisabled] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);

    const onDeleteExistingCard = (data: IOnDeleteACardDTO) => {
        setIsProcessing(false);

        props.getCards();
    };

    const onUpdateOrderCardToUse = () => {
        qbPaymentContext.nextSlide();
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.OrderOnUpdateOrderCardToUse, fn: onUpdateOrderCardToUse },
        { endpoint: EndpointsEnum.PaymentsOnDeleteACard, fn: onDeleteExistingCard },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const selectExistingCard = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        const card = props.existingCards.find((existingCard) => {
            if (value === existingCard.id) {
                return true;
            }
        });

        if (card) {
            console.log("selectExistingCard: ", card);
            setExistingCard(card);
            setIsChargeDisabled(false);
        }
    };

    const renderExistingCardOption = (data: IQBPaymentCard): string => {
        const lastFour = data.number.substring(data.number.length - 4, 4);
        return `${lastFour} - Exp: ${data.expMonth}/${data.expYear}`;
    };

    const useExistingCard = () => {
        let _isChargeDisabled = isChargeDisabled;

        if (existingCard) {
            _isChargeDisabled = false;
        } else {
            _isChargeDisabled = true;
        }

        setIsChargeDisabled(_isChargeDisabled);
    };

    const deleteExistingCard = () => {
        if (existingCard) {
            const payload: IDeleteACardDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: props.orderModel.Vendor!.guid,
                card_id: existingCard.id,
            };

            socket.emit(EndpointsEnum.PaymentsDeleteACard, payload);

            setIsProcessing(true);
            setExistingCard(undefined);
        }
    };

    const updateOrderCardToUse = () => {
        if (existingCard) {
            const payload: IUpdateOrderCardToUseDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: props.orderModel.Vendor!.guid,
                orderGuid: props.orderModel.guid,
                qbo_CardToUseDetail: existingCard,
            };

            socket.emit(EndpointsEnum.OrderUpdateOrderCardToUse, payload);

            qbPaymentContext.setIsLoading(true);
            qbPaymentContext.setExistingCard(existingCard);
        }
    };

    return (
        <div className={"QuickBooksPaymentExistingCards"}>
            <div>
                <div>
                    <div>
                        <OwLabel title={"existing_cards"} />
                        <OwSelectOption
                            titleProp={""}
                            titleRenderFn={renderExistingCardOption}
                            valueProp={"id"}
                            options={props.existingCards}
                            name={"existing_card"}
                            fn={selectExistingCard}
                            isActive={props.getExistingCardsActive}
                            isDisabledOnActive={true}
                            autoSelectSingleOption={false}
                            selectedOption={existingCard}
                            selectedOptionProp={"id"}
                        />
                    </div>
                </div>
                <div className={"mt-4"}>
                    <div className={"d-flex justify-content-center"}>
                        {existingCard ? (
                            <div className={"d-flex justify-content-between w-100"}>
                                <OwButton title={"select_card"} fn={updateOrderCardToUse} />
                                <OwButton
                                    title={"delete_existing_card"}
                                    fn={deleteExistingCard}
                                    active={isProcessing}
                                    disableOnActive={true}
                                    className={"btn-danger"}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};
